import { WEB_URL_INDEX } from '../config'

export const cx = (params) => {
  let cssStr = '';
  Object.keys(params).forEach((item) => {
    if (params[item]) { cssStr += `${item} ` }
  })
  return cssStr.slice(0, -1);
}

export const animateScrollTo = (el, val) => {
  let cval = el.scrollTop
  let dval = val - cval
  const f = 30
  const run = () => {
    dval /= 2
    if (Math.abs(dval) > 10) {
      cval += dval
      el.scrollTop = cval // eslint-disable-line
      window.setTimeout(run, f)
    } else {
      el.scrollTop = val // eslint-disable-line
    }
  }
  run()
}

export const checkIEMode = (ua) => {
  const ReMsie = /MSIE ([0-9]+)/
  if (!ReMsie.test(ua)) return false
  const m = ReMsie.exec(ua);
  if (!m) return false
  const version = m[1]
  return parseInt(version, 10);
}

export const addLogParam = (params) => {
  if (!process.env.BROWSER || !window._rlog) return // eslint-disable-line
  Object.entries(params).forEach(([key, val]) => {
    window._rlog.push(['_addPost', key, val]); // eslint-disable-line
  })
}

export const removeLogParam = (keys) => {
  if (!process.env.BROWSER || !window._rlog) return // eslint-disable-line
  keys.forEach((key) => {
    window._rlog.push(['_removePost', key]); // eslint-disable-line
  })
}

export const trackEventLog = (key, params) => {
  if (!process.env.BROWSER || !window._rlog) return // eslint-disable-line
  if (params) {
    addLogParam(params)
  }
  window._rlog.push(['_trackEvent', key]); // eslint-disable-line
  if (params) {
    removeLogParam(Object.keys(params))
  }
}

export const formatTime = (time) => {
  const date = new Date(time);
  const month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
  const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`;
  const hour = date.getHours() >= 10 ? date.getHours() : `0${date.getHours()}`;
  const min = date.getMinutes() >= 10 ? date.getMinutes() : `0${date.getMinutes()}`;
  return `${date.getFullYear()}-${month}-${day} ${hour}:${min}`
}

export const bindStatusMsg = (code) => {
  switch (code) {
    case 0:
      return '绑定成功'
    case 5:
      return '该账号已绑定'
    default:
      return '绑定失败'
  }
}

// 隐藏手机号中间四位
export function dealMobile(num) {
  let replaceNum = null;
  if (num.indexOf('-') > -1) {
    replaceNum = num.replace(
      /(\+\d+-\d{3})(\d+)(\d{2})/,
      (all, a, b, c) => a + b.replace(/./g, '*') + c,
    );
  } else {
    replaceNum = num.replace(/(\d{3})\d{4}(\d{4})/, '$1 **** $2');
  }
  return replaceNum;
}

// 跳回到登录前页面
export const back2Url = (backurl) => {
  if (/^http/.test(backurl)) {
    window.location.href = backurl;
  } else if (backurl.startsWith('/')) {
    window.location.href = `${WEB_URL_INDEX}${backurl}`
  } else {
    history.push(backurl || '/');
  }
}

export const isMobile = (str) => {
  const mobilePattern =
    '^0*' +
    '(13|15|16|18|14|17|19)' +
    '(' +
    '\\d{9}|' +
    '\\d-\\d{3}-\\d{5}|' +
    '\\d-\\d{4}-\\d{4}|' +
    '\\d{2}-\\d{3}-\\d{4}|' +
    '\\d{2}-\\d{4}-\\d{3}' +
    ')$'; // 13800138000 // 138-001-38000 // 138-0013-8000 // 1380-013-8000 // 1380-0138-000
  const mobileRegExp = new RegExp(mobilePattern);
  const overseaMobileRegExp = /^\d{1,4}-\d+$/;
  if (!str) {
    return false;
  }
  const isChineseMobile = mobileRegExp.test(str);
  const isOverseaMobile = overseaMobileRegExp.test(str);  // 海外手机号
  return isChineseMobile || isOverseaMobile;
};

export const originLoginType = {
  cqq: 'QQ',
  tsina: 'sina',
  'weixin-web-xue': 'weixin',
  urstoken: 'mail',
}



// WEBPACK FOOTER //
// ./src/core/utils.js